import { useState } from "react";
import iasbLogo from '../assets/iasb.png';
import heroLogo from '../assets/hero.svg';
import { RiFlightTakeoffFill } from "react-icons/ri";
import { RiFlightLandFill } from "react-icons/ri";
import mahbLogo from '../assets/mahbLogo.png';
import { FaMapMarkerAlt } from "react-icons/fa";
import { PiMagnifyingGlass } from "react-icons/pi";
import Departure from "../components/Departures";
import Arrivals from "../components/Arrivals";
import { getLocalTimeAbbreviation } from "../utils/common.utils";
interface HomeProps {
    airportName: string,
    openAirportPopup: () => void
}
const HomePage: React.FC<HomeProps> = ({ airportName, openAirportPopup }) => {
    const [activeTab, setActiveTab] = useState<'arrival' | 'departure'>('departure');
    const [searchText, setSearchText] = useState<string>('');

    const handleSearchInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    return (
        <div className="left-0 right-0 bottom-0 absolute grid grid-rows-[auto,auto,1fr] h-full">
            <div className="mx-4 grid grid-cols-1 md:grid-cols-3 gap-2">

                <div className="left-5 p-4 flex justify-between">
                    <img src={mahbLogo} className="h-12 w-auto" alt="MAHB Logo" />
                    <button onClick={openAirportPopup} className="block md:hidden pt-2 flex items-center gap-x-2 text-xl font-semibold text-blue-800 font-mono"><FaMapMarkerAlt className="text-red-600 pb-0.5" />
                        <small style={{fontSize:"xx-small"}}>{airportName}</small>
                        <small className="text-black-800" style={{fontSize:"xx-small"}}>({getLocalTimeAbbreviation()})</small>
                    </button>
                </div>


                {/* Search Bar */}
                <div className="flex flex-col gap-y-4 justify-center items-center">
                    <form className="flex items-center w-full px-4 md:px-0">
                        <label htmlFor="flight-search" className="sr-only">Search</label>
                        <div className="relative w-full">
                            <div className="absolute inset-y-0 left-2 flex items-center pl-4 pointer-events-none">
                                <PiMagnifyingGlass />
                            </div>
                            <input
                                type="text"
                                id="flight-search"
                                className="bg-gray-50 shadow-lg w-full border border-gray-300 text-gray-900 text-lg rounded-full focus:ring-blue-500 focus:border-blue-500 block ps-14 py-4 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                placeholder={activeTab === 'arrival' ? 'Search Flight, Origin, Airline ...' : 'Search Flight, Destination, Airline ...'}
                                value={searchText}
                                onChange={handleSearchInputChange}
                                required
                            />
                        </div>
                    </form>

                    <button onClick={openAirportPopup}  className="hidden md:inline-flex items-center gap-x-2 text-xl font-semibold text-blue-800 font-mono">
                        <FaMapMarkerAlt className="text-red-600" />
                        <span className="leading-none">{airportName}</span>
                        <small className="text-black-800">({getLocalTimeAbbreviation()})</small>
                    </button>
                </div>

                {/* Hero Logo */}
                <div className="fixed p-2 inset-0 flex justify-center items-center md:static md:top-10 md:right-20 -z-10 md:z-auto">
                    <img src={heroLogo} alt="IASB Logo" className="h-48 opacity-10 md:opacity-100 " />
                </div>
            </div>



            <div className="flex justify-center items-center">
                <div className="border-b border-gray-200 dark:border-gray-700">
                    <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400 gap-x-6">
                        <li className="me-2">
                            <button
                                onClick={() => setActiveTab('departure')}
                                className={`inline-flex items-center justify-center p-4 text-2xl md:text-xl sm:text-lg border-b-2 font-bold rounded-t-lg ${activeTab === 'departure'
                                    ? 'text-blue-600 border-blue-600'
                                    : 'border-transparent hover:text-gray-600 hover:border-gray-300'
                                    } dark:hover:text-gray-300 group`}
                            >
                                <RiFlightTakeoffFill size={40} className="mr-2" />
                                <span className="text-lg md:text-2xl sm:text-sm">Departures</span>
                            </button>
                        </li>

                        <li className="me-2">
                            <button
                                onClick={() => setActiveTab('arrival')}
                                className={`inline-flex items-center justify-center p-4 border-b-2 text-2xl md:text-xl sm:text-lg font-bold rounded-t-lg ${activeTab === 'arrival'
                                    ? 'text-blue-600 border-blue-600'
                                    : 'border-transparent hover:text-gray-600 hover:border-gray-300'
                                    } dark:hover:text-gray-300 group`}
                            >
                                <RiFlightLandFill size={40} className="mr-2" />
                                <span className="text-lg md:text-2xl sm:text-sm">Arrivals</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </div>


            <div className="my-2 relative flex-grow bg-gradient-to-b from-blue-100 to-white overflow-hidden">
                {activeTab === 'arrival' && (
                    <div className="md:p-4 absolute inset-0 overflow-auto">
                        <Arrivals searchText={searchText} />
                    </div>
                )}
                {activeTab === 'departure' && (
                    <div className="md:p-4 absolute inset-0 overflow-auto">
                        <Departure searchText={searchText} />
                    </div>
                )}
            </div>

            <div className="flex justify-center items-center space-x-2">
                <p className="text-gray-400 text-sm">Powered by IASB</p>
                <img src={iasbLogo} alt="IASB Logo" className="h-4" />
            </div>
        </div>
    );
};

export default HomePage;
